import { EntityState } from '@ngrx/entity';
import { Security } from '../models/security';

export const COMMON_SECURITY_FEATURE_KEY = 'common.security';

export interface SecuritiesState extends EntityState<Security> {
  loadingIds: number[];
  failedIds: number[];
}
